// extracted by mini-css-extract-plugin
module.exports =  {"link":"SckFs8K"};